import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const rolesStore = {
    actionCreators,
    reducer,
};

export default rolesStore;
